import React from 'react'

export default function Dummy(props) {
    return (
        <div>
            {props.name + " page is coming soon..."}
        </div>
    )
}
